<template>
  <CustomModal @close="$emit('close')">
    <template v-slot:body>
      <div class="edit-goal-modal">
        <div class="col-span-2 text-xl font-bold text-text leading-tight mb-12">{{ $t('formTitle') }}</div>
        <GoalEditForm v-show="!imagePickerShow"
                      :edit-goal="editGoal"
                      @cancel="$emit('close')"
                      @save="submit($event)"/>
        <GoalImagePicker v-show="imagePickerShow"
                         :active-image="goal_image"
                         class="-mx-8 -mt-8"
                         @select="selectGoalImage"
                         @hide="hideImagePicker"/>
        <GoalImagePickerPreview :goal-image="goal_image.goal_image_url"
                                @toggleImagePicker="imagePickerShow = !imagePickerShow"/>
      </div>

    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import GoalEditForm from "@/components/cabinet/Money/Goals/GoalEdit/GoalEditForm";
import GoalImagePickerPreview from "@/components/cabinet/Money/Goals/GoalImagePicker/GoalImagePickerPreview";
import GoalImagePicker from "@/components/cabinet/Money/Goals/GoalImagePicker/GoalImagePicker";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "GoalEditModal",
  components: {GoalImagePicker, GoalImagePickerPreview, GoalEditForm, CustomModal},
  props: {
    editGoal: {
      type: Object
    }
  },
  data() {
    return {
      submitted: false,
      imagePickerShow: false,
      goal_image: {
        goal_image: null,
        goal_image_url: null,
        file: null,
      },
    }
  },
  methods: {
    ...mapActions('space/goals', ['fetchUserGoals', 'updateGoal']),
    selectGoalImage(img) {
      this.goal_image = img;
      this.imagePickerShow = false;
    },
    hideImagePicker() {
      this.imagePickerShow = false;
    },
    async submit(data) {
      try {
        this.submited = true;
        const res = await this.updateGoal({
          ...data,
          goal_image: this.goal_image.goal_image,
        })
        await this.fetchUserGoals();
        if (res.body.success) {
          this.$emit('saved', res.body.data)
        } else {
          this.$toasted.error('Ошибка')
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.submited = false;
      }
    }
  },
  created() {
    this.goal_image.goal_image_url = this.editGoal.goal_image_url;
    this.goal_image.goal_image = this.editGoal.goal_image;
  },
  i18n: {
    messages: {
      en: {
        formTitle: 'Edit goal'
      },
      ru: {
        formTitle: 'Редактирование цели'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-goal-modal {
  @apply grid -mx-8 -mt-12 -mb-12 p-12 bg-white-top-gradient rounded items-start col-gap-12;
  width: 1110px;
  grid-template-columns: 1fr 350px;
  @media(min-width: 1200px) {
    @apply -mx-12;
  }
  @media(max-width: 1199px) {
    grid-template-columns: 1fr 250px;
    width: 760px;
  }
}
</style>